import React from "react";
import { Form, Input } from "antd";
import SelectAddress from "../SelectAddress";

const BillingForm = ({ form, Country, State, City }) => {
    const inputClass = "border-0 border-b-2 rounded-none";
    return (
        <div className="billing-form">
            <h3 className="text-2xl font-medium text-[#252525] mb-6 mt-12">
                Billing information
            </h3>
            <Form.Item
                label="Organization Name"
                className="font-normal"
                name="billingInformationOrganizationName"
                rules={[
                    {
                        required: true,
                        message: "Please enter organization name",
                    },
                ]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 12 }}
            >
                <Input className={inputClass} />
            </Form.Item>
            <SelectAddress
                stateName={{
                    addressLine: "billingInformationAddressLine",
                    country: "billingInformationCountry",
                    state: "billingInformationState",
                    city: "billingInformationCity",
                    pincode: "billingInformationPincode",
                }}
                Country={Country}
                State={State}
                City={City}
                form={form}
            />
            <div className="flex">
                <div className="w-1/2 pr-8">
                    <Form.Item
                        label={"Company Registered Address (CIN)"}
                        name={"billingCompanyRegisteredAddress"}
                        rules={[
                            {
                                required: true,
                                message: `Please enter CIN`,
                            },
                        ]}
                        labelCol={{ span: 24 }}
                    >
                        <Input className={inputClass} />
                    </Form.Item>
                </div>
                <div className="w-1/2">
                    <Form.Item
                        label={"VAT/Tax ID"}
                        name={"billingInformationTaxId"}
                        rules={[
                            {
                                required: true,
                                message: `Please enter Tax ID`,
                            },
                        ]}
                        labelCol={{ span: 24 }}
                    >
                        <Input className={inputClass} />
                    </Form.Item>
                </div>
            </div>

            <div className="flex">
                <div className="w-1/2 pr-8">
                    <Form.Item
                        label={"DUNS Number"}
                        name={"billingInformationDunsNumber"}
                        rules={[
                            {
                                required: true,
                                message: `Please enter DUNS Number`,
                            },
                        ]}
                        labelCol={{ span: 24 }}
                    >
                        <Input className={inputClass} />
                    </Form.Item>
                </div>
            </div>
        </div>
    );
};

export default BillingForm;
